import React, { Fragment } from "react";
import styled from "styled-components";
import { connect } from "formik";
import numeral from "numeral";
import { isEmpty, get } from "lodash";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, FormikInputMoney, FormikInputNumber, LOAN_RATE_TYPES, AMORTIZATION_TYPES, FormikInputText } from "@loanbossinc/component-library";

const Divider = styled.div`&& {    
    border: 1px solid #DADCE0;
    width: 100%;
    height: 0px;
    margin-top:30px;
}`;

const StyledGridContainer = styled(Grid)`&&{
    margin-top: 26px
}`;
const StyledFormikInputNumber = styled(FormikInputNumber)`&&&&{
    width: 100%
}`;
const StyledFormikInputText = styled(FormikInputText)`&&&&{
    width: 100%
}`;
const StyledFormikInputMoney = styled(FormikInputMoney)`&&&&{
    width: 100%
}`;
const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
    border-bottom: 1px solid #2196F3;
    width: 100%;
`;
const StyledHeaderContainer = styled(Grid)`&&{
    margin-top: 23px;
}`;
const StyledHeader = styled.span`&&{
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;

    color: #000000;
}`;

const getFixedFloating = values => {
  const rateTypeId = get(values, "details.rateTypeId");
  if (rateTypeId && rateTypeId === LOAN_RATE_TYPES.FIXED) {
    return 1;
  } else if (rateTypeId && rateTypeId === LOAN_RATE_TYPES.FLOATING) {
    return 2;
  }

  return 0;
};

const AmortizationSection = ({ formik }) => {
  const { values } = formik;

  const amortizationTypeId = get(values, "details.amortizationTypeId");
  const amortizationTypes = values && values.ancillary && values.ancillary.amortizationTypes ? values.ancillary.amortizationTypes : [];
  const showAmortizationTerm = amortizationTypeId === AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT ||
        amortizationTypeId === AMORTIZATION_TYPES.MORTGAGE_STYLE ||
        amortizationTypeId === AMORTIZATION_TYPES.AGENCY_FLOATER;
  const showAmortizationRate = amortizationTypeId === AMORTIZATION_TYPES.MORTGAGE_STYLE;
  const showMonthlyPrincipalReduction = amortizationTypeId === AMORTIZATION_TYPES.STRAIGHT_LINE_CUSTOM_AMORT;
  const isInterestOnly = amortizationTypeId === AMORTIZATION_TYPES.INTEREST_ONLY;

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Amortization</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="details.amortizationTypeId"
          label="Amortization Type"
          options={amortizationTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => { }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      {showMonthlyPrincipalReduction && <StyledGridContainer item xs={12}>
        <StyledFormikInputMoney
          name={"amortizationDetails.monthlyPrincipalReduction"}
          label={"Monthly Principal Reduction ($)"}
          variant={"filled"}
        />
                                        </StyledGridContainer>}

      {showAmortizationTerm && <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={"amortizationDetails.amortizationTerm"}
          label={"Amortization Term (months)"}
          variant={"filled"}
        />
                               </StyledGridContainer>}

      {showAmortizationRate && <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={"amortizationDetails.amortizationRate"}
          label={"Amortization Rate (%)"}
          variant={"filled"}
        />
      </StyledGridContainer>}

      {!isInterestOnly && <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={"amortizationDetails.ioPeriod"}
          label={"Interest Only Periods (months)"}
          variant={"filled"}
        />
      </StyledGridContainer>}

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={"details.amortMisc"}
          label={"Miscellaneous"}
          variant={"filled"}
          multiline
        />
      </StyledGridContainer>
      <Divider />
    </Grid>
  );
};

export default compose(connect)(AmortizationSection);
